import React from 'react';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import IconButton from '@material-ui/core/IconButton';
import Slider from '@material-ui/core/Slider';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  transport: {
    display: 'flex',
    alignItems: 'center',
  },
  transportMobile: {
    display: 'none',
  },
  counterMobile: {
    display: 'none',
  },
  controls: {
    whiteSpace: 'nowrap',
  },
  controlsMobile: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
    width: '100%',
    '& button': {
      width: '33%'
    },
  },
  time: {
    width: 125,
    display: 'block',
    textAlign: 'center',
  },
  loading: {
    animation: 'flash 0.5s linear infinite',
  },
  '@media(max-width: 500px)': {
    time: {
      display: 'none',
    },
  },
}));

const PrettoSlider = withStyles((theme) => ({
  root: {
    color: '#52af77',
    width: 'calc(100% - 4px)',
    margin: '0 20px 0 10px',
    height: 6,
  },
  rail: {
    height: 6,
    backgroundColor: 'red',
    backgroundColor: theme.palette.primary.main,
  },
  track: {
    height: 6,
    borderRadius: 0,
    backgroundColor: theme.palette.primary.light,
  },
  thumb: {
    backgroundColor: '#fff',
    marginTop: -3,
    backgroundColor: theme.palette.primary.main,
  },
}))(Slider);

function Transport(props) {
  const classes = useStyles();
  const { status, play, pause, time, media, onSliderChange } = props;

  const changeTime = (ev, time) => {
    if (!media) return;
    const time2 = parseFloat(time);
    if (time2 < media.getAudioDuration()) {
      media.setAudioTime(time2);
      onSliderChange();
    }
  }

  function displayTime(time) {
    if (isNaN(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = ('0' + Math.floor(time - minutes * 60)).substr(-2);
    return `${minutes}:${seconds}`;
  }

  const renderPlay = () => {
    return (
      <>
        {status === 'paused' && <IconButton onClick={play} title="graj">
          <PlayIcon color="primary" />
        </IconButton>}
        {status === 'playing' && <IconButton onClick={pause} title="stop">
          <PauseIcon color="primary" />
        </IconButton>}
        {status === 'loading' && <IconButton title="loading">
          <HourglassEmptyIcon color="primary" className="animated rotateIn infinite" />
        </IconButton>}
      </>
    );
  }

  const renderTime = () => <div className={classes.time}>({displayTime(time)}/{displayTime(media.getAudioDuration())})</div>
  const renderSlider = () => <PrettoSlider value={time} onChange={changeTime} max={media.getAudioDuration() || 100} />

  return (
    <div className={classes.transport}>
      <div className={classes.controls}>
        <div className={classes.desktop}>{renderPlay()}</div>
      </div>
      {renderTime()}
      {renderSlider()}
    </div>
  );
}

export default Transport;
